import { get, last } from 'lodash'
import { connect } from 'react-redux'
import actions from '../../actions/LifeBenefitsSets'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import BenefitsSetShow from '../BenefitsSet/BenefitsSetShow'
import LifeBenefitsSetComponent from './LifeBenefitsSetComponent'

const mapStateToProps = (state) => {
  const slice = state.lifeBenefitsSets.show

  const configuration = state.login.session.configuration.benefits
  const historySlice = state.benefitsSetFieldHistory.index
  return {
    benefitsSet: slice.attributes,
    rejection: last(get(slice.attributes, 'rejections', [])),
    configuration,
    benefitsSetFieldHistory: historySlice.records,
    productLine: 'Life',
    benefitsSetComponent: LifeBenefitsSetComponent
  }
}

const mapDispatchToProps = {
  show: actions.show.main,
  reset: actions.show.reset,
  history: historyActions.index.main,
  resetHistory: historyActions.index.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetShow)
